import React, { useContext, Suspense } from "react";
import DynamicLayout from "../components/DynamicLayout";
import { PlatformContext } from "../context/PlatformContext";
import { MobileComponents, DesktopComponents, LoadingComponent } from '../helpers/platformUtils';
import NoIndexHelmet from '../components/NoIndexHelmet';

const DeleteAccountPage = () => {
  const { platform, loading } = useContext(PlatformContext);
  
  if (loading) {
    return (
      <DynamicLayout>
        <NoIndexHelmet title="Delete Account | Saturnalia" />
        <LoadingComponent />
      </DynamicLayout>
    );
  }

  const isMobile = platform === 'mobileApp' || platform === 'mobileWeb';
  const MobileComponent = MobileComponents.DeleteAccount;
  const DesktopComponent = DesktopComponents.DeleteAccount;

  return (
    <DynamicLayout>
      <NoIndexHelmet title="Delete Account | Saturnalia" />
      <Suspense fallback={<LoadingComponent />}>
        {isMobile ? (
          <MobileComponent />
        ) : (
          <DesktopComponent />
        )}
      </Suspense>
    </DynamicLayout>
  );
};

export default DeleteAccountPage;
